// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Media_wrapper__533FD","multipleImages":"Media_multipleImages__tadZB"};